const isCompany = name => {
    const hostname = window.location.hostname.split('.')
    return hostname[0] === name
}

export { isCompany }
